import * as React from 'react'
import { FunctionComponent, PropsWithChildren, useEffect } from 'react'
import * as Ariakit from '@ariakit/react'
import { IoCloseSharp as CloseIcon } from 'react-icons/io5'

interface ModalProps {
  openDialog: boolean
  onClose?: () => void
  showClose: boolean
  heading: string
}

const OnboardingModal: FunctionComponent<PropsWithChildren<ModalProps>> = ({
  openDialog,
  onClose = () => {},
  showClose,
  heading,
  children
}) => {
  const dialog = Ariakit.useDialogStore()

  useEffect(() => {
    if (openDialog) {
      dialog.show()
    } else {
      dialog.hide()
    }
  }, [openDialog, dialog])

  const handleDismiss = (event: React.MouseEvent) => {
    if (event.button === 0) {
      onClose()
    }
  }
  const toggleVisibility = () => {
    dialog.hide()
  }

  return (
    <Ariakit.Dialog
      store={dialog}
      hideOnInteractOutside={false}
      backdrop={
        <div
          className='fixed inset-0 bg-black opacity-50'
          onMouseDown={handleDismiss}
        />
      }
      className='fixed z-50 inset-3 w-fit h-fit max-w-screen-lg overflow-x-hidden bg-white text-black mx-auto flex justify-center react-video-modal'
    >
      <div className='w-fit relative'>
        <div
          className='cursor-pointer absolute z-10 right-0 top-0 md:right-6 md:top-6 p-2 text-black'
          onClick={toggleVisibility}
          data-qa-name='button-closePdfPreview'
        >
          {' '}
          {showClose ? <CloseIcon className='fill-black text-3xl' /> : null}
        </div>
        <div className='p-6 lg:p-10 flex flex-col justify-stretch gap-4 md:gap-6 h-auto box-border'>
          <Ariakit.DialogHeading className='text-lg font-light text-center'>
            {heading}
          </Ariakit.DialogHeading>
          <div>{children}</div>
        </div>
      </div>
    </Ariakit.Dialog>
  )
}

export default OnboardingModal
